import { fetchWithAuth } from '@/lib/auth/fetch-with-auth'
import { useDataStore } from '@/lib/machine/use-data-store'
import { useDataStoreLocalStorage } from '@/lib/machine/use-data-store-local-storage'
import { CloudStartInstallationInput } from '@uv/machine'

const CLOUD_SYNC_API_URL = import.meta.env.VITE_CLOUD_SYNC_API_URL
if (!CLOUD_SYNC_API_URL) throw new Error('CLOUD_SYNC_API_URL is not defined')

export const useCloudStartInstallation = () => {
  const mockMode = useDataStore(s => s.mockMode)
  const user = useDataStoreLocalStorage(s => s.user)

  const cloudStartInstallation = async (installationData: CloudStartInstallationInput) => {
    if (mockMode) {
      console.warn('Mock mode is enabled, skipping cloud start installation')
      return () => Promise.resolve()
    }

    if (!user.isAuthenticated) {
      console.warn('User is not authenticated, skipping cloud start installation')
      return () => Promise.resolve()
    }

    const { result: response, error } = await fetchWithAuth(
      `${CLOUD_SYNC_API_URL}/installation/start`,
      {
        method: 'POST',
        body: JSON.stringify(installationData satisfies CloudStartInstallationInput),
        timeout: 2000
      }
    )

    if (error || !response || !response.ok) {
      console.error('Cloud start installation error:', error?.message)
      return
    }
  }

  return cloudStartInstallation
}
